export const getSections = state => state.creditDetail.sections || [];
export const getCurrentCreditDetailQuestionAnswers = state => state.creditDetail.questionAnswers || [];
